module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/paket-mapel"
    }
  }, [_vm._v("Paket Mata Pelajaran")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paket-bimbel"
    }
  }, [_vm._v("Paket Bimbel")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" "), _c('span', [_vm._v("Bimbel Online")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b35c5ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/bimbel_online/components/Navigation.vue
// module id = 2216
// module chunks = 1